import {RoleEnum} from '@pages/global/users/user-types';
import {WorkspaceResource} from '@workspaces/resources';
import {WorkspaceList, workspacesBasePath} from '@workspaces/workspaces';

const basePath = workspacesBasePath[WorkspaceList.GLOBAL];

export const resources: WorkspaceResource[] = [
  {
    name: 'global/records/user',
    list: `${basePath}users`,
    create: `${basePath}users/new`,
    edit: `${basePath}users/edit/:id`,
    meta: {
      label: 'pages.global.user.title',
      prefix: 'pages.global.user',
      dataProviderName: 'treeQL',
      canDelete: true,
      accessControl: {
        [RoleEnum.ROLE_ADMIN]: ['list', 'edit', 'delete', 'create'],
      },
    },
  },
];
